import { render, staticRenderFns } from "./CompDiversityChampionsOtherArticles.vue?vue&type=template&id=0d66c17a&scoped=true"
import script from "./CompDiversityChampionsOtherArticles.vue?vue&type=script&setup=true&lang=js"
export * from "./CompDiversityChampionsOtherArticles.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d66c17a",
  null
  
)

export default component.exports